import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { KPIDefinition } from "@/types/kpiTypes.ts"

export const getAllKPIs = async (): Promise<KPIDefinition[]> => {
  const { data, error, response } = await apiClient.GET("/api/KPIs")
  return assertOk(response, error, data)
}
